import { Box } from '@chakra-ui/react';

import { DataProviderQueryStatus } from '../../DataProvider/types';
import { useRegisterSharedChartData } from '../../SharedReport/SharedReportDataContext';
import { useTextChartContent } from '../../TextChartContentProvider/TextChartContentProvider';
import { ChartFallback } from '../ChartFallback';
import { useChart } from '../ChartProvider';
import { MarkdownRenderer } from '../TextChart/MarkdownRenderer';

export const AiSummaryChart = () => {
  const { item } = useChart();
  const { aiSummary } = useTextChartContent();
  const { summary, loading, error } = aiSummary;

  const status = (() => {
    if (loading) {
      return DataProviderQueryStatus.Fetching;
    }
    if (error) {
      return DataProviderQueryStatus.Error;
    }
    return DataProviderQueryStatus.Success;
  })();

  const markdownContent = item?.plot?.textHtml
    ? `${item.plot.textHtml}\n\n${summary}`
    : summary;

  useRegisterSharedChartData(item.id, {
    markdown: summary ? markdownContent : undefined,
  });

  return (
    <ChartFallback status={status} errorMessage={error ?? undefined}>
      <Box
        height="100%"
        overflow="hidden"
        display="flex"
        flexDirection="column"
        paddingX="0.5rem"
      >
        <Box color="text.primary" height="100%">
          <MarkdownRenderer content={markdownContent} />
        </Box>
      </Box>
    </ChartFallback>
  );
};
